export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-force/src/constant.js
// module id = tdYb
// module chunks = 0